<template>
  <div>
    <div class="w-100 px-0 px-lg-2">
      <div class="container-fluid px-0">
        <div class="w-100 d-flex flex-row">
          <!-- home -->
          <div class="link-type">
            <router-link :to="'/'" class="breadcrumbs text-yellow">
              Home
            </router-link>
          </div>
          <div class="mx-2">
            <span class="text-yellow">></span>
          </div>
          <div class="link-type" v-if="type == 'vod'">
            <router-link :to="'/vod'" class="breadcrumbs text-yellow">
              Vod
            </router-link>
          </div>
          <div class="link-type" v-if="type == 'podcast'">
            <router-link :to="'/podcast'" class="breadcrumbs text-yellow">
              Podcast
            </router-link>
          </div>
          <div class="mx-2" v-if="type">
            <span class="text-yellow">></span>
          </div>
          <div class="link-type" v-if="category">
            <router-link :to="category_link" class="breadcrumbs text-yellow">
              {{ category }}
            </router-link>
          </div>
          <div class="mx-2" v-if="category">
            <span class="text-yellow">></span>
          </div>
        </div>
        <div class="w-100 d-flex flex-row justify-content-start mt-2">
          <div class="link-type breadcrumbs text-yellow" v-if="currentPage">
            {{ currentPage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "breadcrumbs-header",
  props: ["type", "category", "category_link", "currentPage"],
};
</script>

<style scoped>
.link-type {
  width: auto;
  padding: 0 8px 0 0;
}
.item-header-title {
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  color: #facb43;
}
.breadcrumbs-mobile {
  display: none;
}
.breadcrumbsWrapper {
  position: absolute;
  right: 8px;
  display: flex;
  justify-content: flex-end;
}
.breadcrumbs {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.19;
  text-align: left;
}
.text-white {
  color: #e6e6e6;
}
.text-yellow {
  color: #facb43;
}

@media only screen and (max-width: 768px) {
  .breadcrumbs-mobile {
    display: flex;
    justify-content: flex-start;
  }
  .breadcrumbsWrapper {
    display: none;
  }
  .breadcrumbs {
    font-size: 12px;
  }
  .item-header-title {
    font-size: 20px;
  }
}
</style>
